module.exports = __webpack_public_path__ + "static/media/DSC01442.353e2952.jpg";